import React from 'react';
import { css } from 'aphrodite';
import styles from './scheduled-bookings-styles';
import { ContentCard, ContentRow } from '../common';
import BookingSummary from '../booking-summary/booking-summary';

const ScheduledBookingsView = (props) => (
  <div className={css(styles.root)}>
    {/*<ContentCard title={'Live bookings'}>*/}
      {/*{(props.liveBookings.journeyReports || []).map(booking => (*/}
        {/*<BookingSummary*/}
          {/*key={booking.id}*/}
          {/*booking={booking}*/}
        {/*/>*/}
      {/*))}*/}
    {/*</ContentCard>*/}
    <ContentCard title={'Scheduled bookings'}>
      {(props.scheduledBookings.journeyReports || []).map(booking => (
        <BookingSummary
          key={booking.id}
          booking={booking}
        />
      ))}
    </ContentCard>
  </div>
);

export default ScheduledBookingsView;



// WEBPACK FOOTER //
// ./src/components/scheduled-bookings/scheduled-bookings-view.js